import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice';
import robotsReducer from './features/robots/robotsSlice';
import mapsReducer from './features/maps/mapsSlice';
import websocketReducer from './features/websocket/websocketSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    robots: robotsReducer,
    maps: mapsReducer,
    websocket: websocketReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: { ignoredPaths: ['websocket.telemetry'] } }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
